import { type AxiosInstance } from 'axios'

type UnitPayload = {
  conversion_factor: number
  description: string
  measurement_common_identifier: string
  name: string
}
type Units = {
  common_identifiers: string[]
}
interface CreateCompanyIntegrationData {
  name: string
  company: number
  company_location?: number | null
  category?: number | null
  type: number
  option?: number | null
  unit?: number | null
  question?: number | null
  source?: number | null
  endpoint: string
  aggregation_period: string
  aggregation_type?: 'discrete' | 'aggregation'
  slope?: number | null
  api_key_data_name?: string | null
  api_key_date_name?: string | null
  api_username?: string | null
  api_password?: string | null
  offset?: number | null
  disabled?: boolean
  headers: {
    name: string
    value: string
  }[]
  parameters: {
    name: string
    value: string
  }[]
}

export default (axios: AxiosInstance) => ({
  listCurrencies() {
    return axios.get('/v1/units/measurements/8/units/')
  },
  listAll() {
    return axios.get('/v1/units/')
  },
  async listUnits(measurentId: number | string) {
    const { data } = await axios.get(`/v1/units/measurements/${measurentId}/units/`)
    return data
  },
  listCompanyIntegrations(companyId: number | string) {
    return axios.get(`/v1/integrations/${companyId}/api-integrations/get/`)
  },
  createCompanyIntegration(companyId: number | string, createData: CreateCompanyIntegrationData) {
    return axios.post(`/v1/integrations/${companyId}/api-integrations/create/`, createData)
  },
  updateCompanyIntegration(dataPointInd: number | string) {
    return axios.put(`/v1/integrations/${dataPointInd}/disable/`)
  },
  listUnitCategory(categoryId: number | string) {
    return axios.get(`/v1/units/category/${categoryId}/`)
  },

  getUnits() {
    return axios.get('/v1/units/')
  },
  getUnitDetails(id: number | string) {
    return axios.get(`/v1/units/${id}/`)
  },
  createUnit(unitData: UnitPayload) {
    return axios.post(`/v1/units/`, unitData)
  },
  updateUnit(id: number, unitData: UnitPayload) {
    return axios.put(`/v1/units/${id}/`, unitData)
  },
  deleteMultipleUnits(data: Units) {
    return axios.delete('/v1/units/delete/multiple-delete/', { data })
  },
})
